<!-- <Loader :loading="loading" /> -->
<div class="d-flex align-items-center temporary-post" v-if="temporary_post" id="temp-post">
    <p class="text-xxs fw-bold">{{ temporary_post.document_name }} - Posting...</p>
    <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
</div>
<!-- Events (restyled like your “past_events” cards) -->
<div class="d-flex flex-wrap justify-content-end align-items-center gap-3 px-3 mb-2 text-xxs">
  <span class="d-inline-flex align-items-center gap-1">
    <i class="bi bi-square-fill text-primary" aria-hidden="true"></i>
    Published events
  </span>
  <span class="d-inline-flex align-items-center gap-1">
    <i class="bi bi-square-fill text-warning" aria-hidden="true"></i>
    Unpublished events
  </span>
</div>
<div class="calendar-wrapper" :class="{ 'is-events-loading': is_loading_events }">
<full-calendar ref="calendar" :options="calendarOptions"></full-calendar>
  <div v-if="is_loading_events" class="events-loading-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-opacity-25" aria-live="polite" aria-busy="true">
    <div class="events-loading-banner d-flex align-items-center gap-3 p-3 rounded-4 bg-white border shadow-sm mx-3 w-100 justify-content-center text-center">
      <div class="events-loading-spinner spinner-border text-primary" role="status" aria-hidden="true"></div>
      <div class="events-loading-text">
        <div class="events-loading-title fw-bold">Loading events</div>
        <div class="events-loading-subtitle small text-muted">Please wait…</div>
      </div>
    </div>
  </div>
</div>

<!-- Event Creation -->
<teleport to="body">
    <div class="modal fade" id="event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable modal-fullscreen-sm-down">
      <div class="modal-content rounded-3 shadow-lg">
        <div class="modal-header border-0 shadow-sm bg-primary d-flex justify-content-center text-center position-relative">
          <h5 class="modal-title text-xs text-white start-50 translate-middle-x position-absolute">Add Event</h5>
          <button
            type="button"
            class="btn-close btn-close-white text-xs"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="event_id ? update_event() : submit_event_form()">
          <div class="modal-body modal-body-scroll px-4 pt-3 pb-4">

            <div class="mb-3">
              <label for="event_name" class="form-label text-xxs fw-500">Event Name</label>
              <input type="text" class="form-control rounded text-xxs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xxs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <label class="form-label text-xxs fw-500">Event Category</label>
            <div class="d-flex flex-row align-items-center gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio" id="free_event"
                  :value="true"
                  v-model="is_free"
                  checked
                />
                <label class="form-check-label text-xxs" for="free_event">Free</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="paid_event"
                  :value="false" v-model="is_free"

                />
                <label class="form-check-label text-xxs" for="paid_event">Paid</label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label text-capitalize">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xxs">{{ errors.event_type }}</p>
            </div>
             <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <input id="event_link" type="url" class="form-control rounded text-xxs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xxs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
             <input ref="mapInput" id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xxs">{{ errors.location }}</p>
            </div>

          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <label for="start_date" class="form-label text-xxs fw-500">
                Event start date <span class="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                class="form-control rounded text-xxs input-dark"
                id="start_date"
                v-model="start_date"
                :min="min_datetime"
              >
              <p v-if="errors.start_date" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.start_date }}
              </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <label for="end_date" class="form-label text-xxs fw-500">
                Event end date <span class="text-danger">*</span>
              </label>
              <input
                type="datetime-local"
                class="form-control rounded text-xxs input-dark"
                id="end_date"
                v-model="end_date"
                :min="min_datetime"
              >
              <p v-if="errors.end_date" class="text-danger text-xxs mt-1 mb-0">
                {{ errors.end_date }}
              </p>
            </div>
          </div>
          </div>

          <div class="modal-footer border-top bg-white shadow-sm px-4 py-3 d-flex gap-2">
            <button type="submit" class="btn btn-primary text-xxs rounded cursor-pointer" :disabled="!is_valid_event">Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
<div class="modal fade" id="eventModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded border-0 shadow-sm">
      <div class="modal-header border-0">
        <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body modal-body-scroll d-flex flex-column align-items-center text-center">

        <img src="https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/thank-you.webp" class="w-150" alt="">
        <h6 class="text-center">Thank you for registering</h6>
        <p class="text-center">Please confirm your RSVP below</p>

        <!-- JOIN LINK FOR ONLINE EVENTS -->
        <div v-if="(selectedEvent.event_type?.name === 'online') && selectedEvent.event_link">
          <a v-if="isEventStarted(selectedEvent).canJoin"
             :class="['btn', 'btn-sm', 'fw-500', 'me-2', 'btn-primary']"
             :href="selectedEvent.event_link">
            Join Event
          </a>
          <p v-else class="text-muted text-sm mt-1">
            {{ isEventStarted(selectedEvent).message }}
          </p>
        </div>

        <!-- RSVP / CANCEL LOGIC -->
        <div v-if="selectedEvent.event_type?.name !== 'online' ">
          <span v-if="!isWithinRSVPPeriod(selectedEvent).isValid" class="d-inline-block">
            <p class="text-danger text-xxs">{{ isWithinRSVPPeriod(selectedEvent).message }}</p>
          </span>

          <button v-else class="gap-3" :class="[
                    'btn',
                    'btn-sm',
                    'fw-500',
                    'me-2',
                    selectedEvent.is_rsvped ? 'btn-warning' : 'btn-primary'
                  ]" @click="handle_rsvp(selectedEvent)">
            {{ selectedEvent.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="event_list_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Attendees for this event</h5>
          <button v-if="(user_details.user_role==='admin' ||String(event?.user?.id) === String(get_user_id())) && token_exists" class="btn btn-sm btn-secondary text-xxs ms-2 shadow" @click="exportToCSV(selectedEvent)">
            Export RSVP
          </button>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body table-responsive">
          <table class="table table-striped text-xxs">
            <thead>
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone Number</th>
                <th v-if="cbo_domain" scope="col">Business Name</th>
                <th v-if="cbo_domain" scope="col">First Time attending?</th>
                <th v-if="cbo_domain" scope="col">Chapter</th>
                <th scope="col">Meal</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in selectedEvent.rsvp_list" :key="user.id">
                <td>{{user.user?.first_name}}</td>
                <td>{{user.user?.last_name}}</td>
                <td>{{user.user?.email}}</td>
                <td>{{user.user?.phone_number}}</td>
                <td v-if="cbo_domain">{{user.business_name}}</td>
                <td v-if="cbo_domain">{{user.is_first_time ? 'Yes' : 'No' }}</td>
                <td v-if="cbo_domain">{{user.chapter}}</td>
                <td>
                  <span v-for="extra in user.rsvp_items">{{extra.item.item_name}},</span>
                </td>
                <td>
                  <button
  class="btn btn-sm btn-danger fw-500 text-xxs"
  @click="cancelRSVP(selectedEvent.id, user.user.id)">
  Cancel RSVP
</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
<div class="modal fade" id="rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3 bg-light">

           <div class="modal-header bg-primary d-flex align-items-center">
              <i class="bi bi-ticket-perforated-fill text-white fs-4 me-2"></i> <!-- me-2 adds right margin -->
              <h5 class="modal-title fw-bold mb-0 fs-5 text-white" id="exampleModalLabel">RSVP</h5>
              <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
          </div>


            <form @submit.prevent="addRsvp">
                <div class="modal-body overflow-auto modal-scroll" >

                    <!-- Business Name -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="businessName" class="form-label fw-semibold small text-secondary">Provide business name</label>
                        <input type="text" v-model="businessName" placeholder="Business Name" class="form-control rounded">
                    </div>

                    <!-- First Time Attending -->
                    <div v-if="cbo_domain" class="mb-3">
                        <label for="firstTimeSelect" class="form-label fw-semibold small text-secondary">Is this your first time attending?</label>
                        <select v-model="isFirstTime" class="form-select rounded" id="firstTimeSelect">
                            <option disabled value="">Please select an option</option>
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>

                    <!-- Home Chapter -->
                    <div v-if="cbo_domain" class="mb-4">
                        <label for="chapterSelect" class="form-label fw-semibold small text-secondary">Home Chapter</label>
                        <select v-model="chapter" class="form-select rounded" id="chapterSelect">
                            <option disabled value="">Please select a chapter</option>
                            <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
                        </select>
                    </div>

                    <!-- Divider before extras -->
                    <div v-if="eventExtras.length > 0" class="border-top mb-4 pt-4"></div>

                    <!-- Menu Selection -->
                                          <!-- Menu Selection -->
                     <div v-for="extra in eventExtras" :key="extra.id" class="mb-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <i class="bi bi-star text-secondary fs-6"></i> 
                            <label class="form-label text-uppercase fw-bold mb-0 small text-primary">{{ extra.extra.name }}</label>
                        </div>

                        <div class="d-flex flex-column gap-2">
                            <div v-for="item in extra.items" :key="item.item_name"
                                class="border rounded px-3 d-flex align-items-center gap-3 cursor-pointer"
                                @click="toggleItem(item.id)">

                                <!-- Checkbox -->
                                <input class="form-check-input mt-0 me-3" type="checkbox"
                                      :name="item.item_name" :id="item.item_name"
                                      v-model="selectedItemId" :value="item.id"
                                      @click.stop>

                                <!-- Item info -->
                                <div class="flex-grow-1 d-flex justify-content-between align-items-center">
                                    <div>
                                        <div class="fw-semibold mt-3">{{ item.item_name }}</div>
                                        <div class="text-muted small">{{ item.description }}</div>
                                    </div>
                                    <div v-if="!workbook_domain" class="fw-bold text-primary small">R{{ item.price }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Validation Message -->
                    <div v-if="formError" class="alert alert-danger mt-3 py-2 px-3 small">
                        <strong>⚠️</strong> Please select at least one item to RSVP.
                    </div>

                    <!-- Dietary Restrictions (hidden) -->
                    <div class="mb-3 d-none">
                        <label class="form-label fw-semibold small">Additional Restrictions</label>
                        <textarea class="form-control rounded" rows="2" placeholder="Please specify any allergies or restrictions" v-model="dietaryRestrictions"></textarea>
                    </div>
                </div>

                <div class="modal-footer border-top py-3 bg-light">
                    <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="!selectedItemId.length">Submit</button>
                    
                </div>
            </form>

        </div>
    </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="ticket_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
    <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">

      <!-- HEADER -->
      <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10 p-3">
        <div class="portal-event-modal-heading d-flex align-items-center gap-2 flex-grow-1">
            <h6 class="marketplace-card-name mb-0 text-primary fw-bold text-truncate" id="exampleModalLabel">
              {{ selected_event?.event_name }}
            </h6>
          </div>
        <button
          type="button"
          class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
          data-bs-dismiss="modal"
          aria-label="Close">
          <i class="fas fa-times fs-6"></i>
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- Event Info -->
        <div class="text-start mb-3">
          <p class="mb-1 text-muted">
            <i class="bi bi-calendar-event"></i>
            {{ formatDate(selectedEvent?.start_date) }}
          </p>
          <p class="mb-1 text-muted" v-if="selectedEvent?.location">
            <i class="bi bi-geo-alt"></i>
            {{ selectedEvent.location }}
          </p>
          <span class="badge bg-light text-dark border rounded-pill" v-if="!selectedEvent?.is_free">
            Paid Event
          </span>
        </div>

        <!-- Tickets Section -->
        <p class="text-xxs">Select Tickets</p>
        <div v-if="event_tickets.length === 0" class="text-center py-4">
          <p class="text-muted text-xxs mb-0">No available tickets for this event.</p>
        </div>

        <div v-else>
        <div v-for="ticket in event_tickets" :key="ticket.id"
          class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">

        <!-- Ticket Info -->
        <div class="text-start">
          <div class="fw-500">
            {{ ticket?.ticket?.name }}
           <span v-if="ticket.is_sold_out" class="badge bg-danger text-xxs rounded ms-2">Sold Out</span>
          </div>
          <div class="text-success fw-bold">
            R{{ ticket?.price }}
          </div>
    <small class="text-muted" v-if="ticket.available_instances > 0">
      Available: {{ ticket.available_instances - (ticket.quantitySelected || 0) }}
    </small>
        </div>

        <!-- Counter -->
        <div v-if="validate_ticket_date(ticket?.start_date)" class="d-inline-flex align-items-center border rounded px-2">
          <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.max(0, (ticket.quantitySelected || 0) - 1)">
            –
          </button>
          <span class="px-3">{{ ticket?.quantitySelected }}</span>
          <button class="btn btn-sm text-xxs rounded border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.min(ticket.available_instances, (ticket.quantitySelected || 0) + 1)">
            +
          </button>
        </div>
        <div v-else>
          <span class="badge rounded-pill bg-primary px-3 py-2 fw-light text-uppercase shadow-sm">Coming Soon</span>
        </div>
      </div>
      </div>


      </div>

      <div class="promo-section-modal px-3 pb-2">
        <div>
          <div class="d-flex align-items-center mb-2">
            <label class="text-muted text-xs mb-0 me-1">Have a promo code?</label>
            <i class="bi bi-question-circle-fill text-muted cursor-pointer text-xxs"></i>
          </div>

          <div class="d-flex gap-2">
            <div class="flex-grow-1">
              <input
                type="text"
                v-model="promo_input"
                class="form-control rounded text-xxs"
                placeholder="Enter promo code"
                :disabled="is_applying"
              />
            </div>
            <button
              class="btn btn-primary btn-sm text-xxs rounded px-4"
              type="button"
              :disabled="!promo_input || is_applying"
              @click="apply_promo"
            >
              <span v-if="is_applying" class="spinner-border spinner-border-sm me-1"></span>
              Apply code
            </button>
          </div>

          <transition name="fade">
            <p
              v-if="promo_message"
              :class="['text-xs mt-2 mb-0', promo_status === 'success' ? 'text-success' : 'text-danger']"
            >
              {{ promo_message }}
            </p>
          </transition>

          <div class="mt-2 text-end">
            <div v-if="applied_promo" class="text-success text-xxs mb-1">
              <i class="bi bi-tag-fill"></i>
              Applied:
              {{ applied_promo?.promo_code.promo_code_type?.name === 'percentage' ? applied_promo?.promo_code.discount_amount + '%' : 'R' + applied_promo?.promo_code.discount_amount }} off
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer d-flex justify-content-between align-items-center border-0">
        <p class="fw-bold text-xxs mb-0">Total: R{{ calculate_total() }}</p>
        <button class="btn btn-primary btn-sm text-xxs rounded px-4" @click="process_to_checkout" :disabled="!event_tickets || event_tickets.length === 0 || calculate_subtotal() <= 0"> Proceed To Checkout</button>
      </div>

    </div>
  </div>
</div>
</teleport>

<!-- Attendees list view -->
<teleport to="body">
  <div class="modal fade" id="event_user_ticket" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Attendees for this event</p>
          <button v-if="(user_details.user_role==='admin' || String(selectedEvent?.user?.id) === String(get_user_id())) && token_exists" class="btn btn-sm btn-secondary rounded text-xxs ms-2 shadow" @click="exportTicketsToCSV(event_ticket_attendees)">
            Export Ticket Users
          </button>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body table-responsive">
          <table class="table table-striped text-xxs">
            <thead>
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Ticket Name</th>
                <th scope="col">Ticket Code</th>
                <th scope="col">Redeemed</th>
                <th scope="col">Purchased At</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in event_ticket_attendees" :key="user.id">
                <td>{{user?.first_name}}</td>
                <td>{{user?.last_name}}</td>
                <td>{{user?.email}}</td>
                <td>{{ user.ticket_name }}</td>
                <td>{{ user.unique_code }}</td>
                <td>{{ user.is_redeemed ? 'Yes' : 'No' }}</td>
                <td>{{ newFormatDate(user.order_date) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Tickets Scanning -->
<teleport to="body">
  <div class="modal fade" id="scanModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">Scan Ticket</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="stopScanning"></button>
        </div>
        <div class="modal-body text-center p-3">
          <video id="video" autoplay playsinline
                class="w-100 rounded shadow-sm"
                ></video>
          <canvas id="canvas" hidden></canvas>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
   <div class="modal fade" id="view_event" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
      <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
        <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10 p-3">
          <div class="portal-event-modal-heading d-flex align-items-center gap-2 flex-grow-1">
            <h6 class="marketplace-card-name mb-0 text-primary fw-bold text-truncate" id="exampleModalLabel">
              {{ selected_event?.event_name }}
            </h6>
            <span
              v-if="selected_event"
              class="badge text-xxs text-uppercase rounded-pill px-2 py-1 fw-bold"
              :class="selected_event.is_published ? 'bg-success' : 'bg-warning text-dark'"
            >
              {{ selected_event.is_published ? 'Published' : 'Draft' }}
            </span>
          </div>
          <button
            type="button"
            class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="fas fa-times fs-6"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-start mb-4">
          <div class="d-flex align-items-center w-100 gap-2">
            <div class="d-flex align-items-center flex-wrap gap-2 flex-grow-1">
              <span class="badge bg-banner-gradient rounded border text-xxs me-1">
                {{ daysUntil(selected_event?.start_date) }}
              </span>
              <div v-if="selected_event?.is_published">
                <template v-if="show_ticket_rsvp_card(selected_event)">
                  <button
                    v-if="selected_event?.is_rsvped"
                    class="btn btn-sm btn-danger text-xxs rounded px-3 py-1 me-2"
                    @click.stop="cancelRSVP(selected_event.id)"
                  >
                    Cancel RSVP
                  </button>

                  <button
                    v-else-if="selected_event?.is_free"
                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 me-2"
                    @click.stop="openModal()"
                  >
                    RSVP
                  </button>

                  <button
                    v-else-if="!selected_event?.is_free && token_exists"
                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 me-2"
                    @click.stop="openModal(selected_event)"
                  >
                    Buy Ticket
                  </button>
                </template>

                <!-- Scan (hidden by default) -->
                <button
                  v-if="can_manage_selected_event()"
                  class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 me-2"
                  @click.stop="startScanning(selected_event.id)"
                >
                  Scan Ticket
                </button>
            </div>
            </div>
            <div
              class="dropdown ms-auto flex-shrink-0"
              v-if="can_manage_selected_event()"
              @click.stop
            >
              <button
                class="btn btn-light btn-sm rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-three-dots-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end custom-dropdown lh-1" v-if="token_exists">
                <li>
                  <a class="dropdown-item text-xxs fw-bold" href="" @click.prevent="edit_event(selected_event)">
                    Edit
                  </a>
                </li>
                <li>
                  <a class="dropdown-item text-xxs fw-bold" href="" @click.prevent="deleteEvent(selected_event.id)">
                    Delete
                  </a>
                </li>
              </ul>
            </div>
          </div>
          </div>
          <hr class="my-1">

        <!-- Info Grid -->
        <div class="row g-4 mb-4">
          <!-- Event Period -->
          <div class="col-12 col-md-4">
            <div class="d-flex gap-3">
              <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                <i class="bi bi-calendar-event fs-5 text-secondary"></i>
              </div>
              <div class="flex-grow-1">
                <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period</div>
                <div class="fw-semibold text-xxs">{{ formatDate(selected_event?.start_date) }}</div>
                <div class="text-muted text-xxs">
                  {{ selected_event?.start_time ? form_time(selected_event?.start_time) : '' }}
                  <span v-if="selected_event?.end_time"> to {{ form_time(selected_event?.end_time) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Location -->
          <div class="col-12 col-md-4">
            <div class="d-flex gap-3">
              <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                <i class="bi bi-geo-alt fs-5 text-secondary"></i>
              </div>
              <div class="flex-grow-1">
                <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location</div>
                <div class="fw-semibold text-xxs">{{ selected_event?.location || 'Not set' }}</div>
              </div>
            </div>
          </div>

           <!-- Organizer & Attendees -->
          <div class="col-12 col-md-4">
            <div class="d-flex gap-3">
              <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                <i class="bi bi-people fs-5 text-secondary"></i>
              </div>
              <div class="flex-grow-1">
                <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Organizer</div>
                <div class="fw-semibold text-xxs mb-1">{{ selected_event?.organizer }}</div>

                <!-- Attendees chips -->
                <div class="text-xxs">
                  <!-- Free events: open list modal -->
                  <span
                    v-if="selected_event?.is_free && can_manage_selected_event()"
                    class="badge bg-banner-gradient border rounded text-xxs d-inline-flex align-items-center gap-1"
                    @click.stop="selectEvent(selected_event)"
                    data-bs-toggle="modal"
                    data-bs-target="#event_list_modal"
                  >
                    <i class="bi bi-people"></i> {{ selected_event?.rsvp_count }} Attendees
                  </span>

                  <!-- Paid events: invoke view_attendees -->
                  <span
                    v-if="!selected_event?.is_free && can_manage_selected_event()"
                    class="badge bg-banner-gradient border rounded text-xxs d-inline-flex align-items-center gap-1"
                    @click.stop="view_attendees(selected_event)"
                  >
                    <i class="bi bi-ticket-perforated"></i> View Attendees
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Description -->
        <div v-if="check_description(selected_event?.description)" class="mt-2">
          <div class="text-uppercase text-muted small fw-semibold mb-2">Description</div>
          <p class="mb-0 text-xxs text-muted" v-html="selected_event?.description"></p>
          </div>
        </div>
         <div class="d-flex justify-content-end gap-2 mt-3">
            <button
              type="button"
              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 ms-auto"
              @click.stop="go_to_view_event(selected_event)">
              View Event
            </button>
            <button
              v-if="can_manage_selected_event()"
              type="button"
              class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
              @click.stop="go_to_manage_event(selected_event)">
              Manage Event
            </button>
        </div>
        </div>
      </div>
    </div>
   </div>
</teleport>
